module.exports = __webpack_public_path__ + "static/media/24-Viñas(1).74c92c96.png";